export class CellFormatPart {
  constructor ({ variables, ...config }) {
    Object.keys(config).forEach((key) => {
      this[key] = config[key]
    })

    this.variables = variables || []
  }
}
